export default "__VITE_ASSET__DbLX$XRA__"